<template>
  <span>
    <feather-icon
      v-b-tooltip.hover.top="
        $t(
          `Global.${
            $can($acl.action.Update, $acl.subjects.Countries)
              ? 'EditSubject'
              : 'ViewSubject'
          }`,
          { subject: $t('Management.Countries.Country') }
        )
      "
      :icon="
        $can($acl.action.Create, $acl.subjects.Countries)
          ? 'Edit2Icon'
          : 'EyeIcon'
      "
      size="16"
      class="hover-primary"
      @click="openSideBar"
    />
    <Form
      ref="form"
      :country="updatedData"
      :submit-btn-text="`${$t('Global.Save')} ${$t(
        'Management.Countries.Country'
      )}`"
      :can="$can($acl.action.Create, $acl.subjects.Countries)"
      :header="
        $t('Management.Countries.Country') + ' ' + $tc('Global.EditSubject')
      "
      @submit="submit"
    />
  </span>
</template>
<script>
import Form from "./form.vue";

export default {
  components: {
    Form,
  },

  props: {
    country: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    updatedData: null,
  }),

  methods: {
    openSideBar() {
      this.updatedData = this.country;
      this.$refs.form.sidebarVisible = true;
    },
    async submit() {
      try {
        const { data } = await this.$axios.patch(
          `countries/${this.country.id}`,
          this.updatedData
        );

        this.$alert.update(data.name);

        Object.keys(this.updatedData).forEach((key) => {
          this.country[key] = this.updatedData[key];
        });

        const { form } = this.$refs;
        form.dirty = false;
        form.sidebarVisible = false;
      } catch {
        this.$alert.error();
      }
    },
  },
};
</script>